import { useI18n } from "../i18n";
import { LangSwitch } from "./LangSwitch";
import { LogOut, Play, Coins } from "lucide-react";
import { creditsLeft } from "./TrialCard";

const sessionNote = (user, t) => {
  if (user.subscription?.active) return t("noteSub");
  if (user.trial?.active) return t("noteTrial");
  return "";
};

export const HomeHeader = ({ user, onLogout }) => {
  const { t } = useI18n();
  return (
  <header className="flex items-center justify-between fade-in">
    <div className="flex items-center gap-3">
      <img src="/logo192.png" alt="Voci Oltre" className="w-11 h-11 logo-img" data-testid="home-logo" />
      <span className="font-heading font-black text-xl tracking-wide" data-testid="home-brand">VOCI OLTRE</span>
    </div>
    {user ? (
      <div className="flex items-center gap-4">
        <LangSwitch />
        <span className="font-mono text-sm text-amber flex items-center gap-2" data-testid="home-credits"><Coins size={14} />{creditsLeft(user)} {t("credits")}</span>
        <button className="icon-btn" onClick={onLogout} data-testid="logout-btn" title={t("logout")}><LogOut size={14} /></button>
      </div>
    ) : <LangSwitch />}
  </header>
  );
};

const HeroAction = ({ user, loading, onStart, onLogin }) => {
  const { t } = useI18n();
  if (loading) return null;
  if (user) {
    return <button className="power-btn" onClick={onStart} data-testid="home-start-session-btn"><Play size={18} /> {t("start")}</button>;
  }
  return <button className="power-btn" onClick={onLogin} data-testid="google-login-btn">{t("login")}</button>;
};

export const HomeHero = ({ user, loading, onStart, onLogin }) => {
  const { t } = useI18n();
  return (
  <section className="grid lg:grid-cols-[1fr_auto] gap-10 items-center py-10 fade-in">
    <div className="grid gap-6">
      <p className="label text-cyan">{t("tagline")}</p>
      <h1 className="font-heading font-black text-3xl sm:text-4xl lg:text-5xl leading-[1.1] max-w-2xl">
        {t("heroA")} <span className="text-amber glow-amber">{t("heroB")}</span>.
      </h1>
      <p className="text-muted max-w-xl text-base">{t("heroText")}</p>
      <div className="flex flex-wrap gap-4 mt-4"><HeroAction user={user} loading={loading} onStart={onStart} onLogin={onLogin} /></div>
      {user && <p className="font-mono text-xs text-subtle">{t("hello")} {user.name}. {sessionNote(user, t)}</p>}
    </div>
    <img src="/logo.png" alt="" className="hidden lg:block w-72 h-72 logo-hero" data-testid="home-hero-logo" />
  </section>
  );
};
